import { render, staticRenderFns } from "./BadgesReport.vue?vue&type=template&id=84a2c608&scoped=true"
import script from "./BadgesReport.vue?vue&type=script&lang=js"
export * from "./BadgesReport.vue?vue&type=script&lang=js"
import style0 from "./BadgesReport.vue?vue&type=style&index=0&id=84a2c608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a2c608",
  null
  
)

export default component.exports